import { SearchResult } from "./search-result";

export type FeatureFlagChangeSet = { [flag: string]: boolean };

export type FeatureFlagSet = {
    [name: string]: {
        DefaultValue: boolean;
        ExplicitlyOnCount: number;
        ExplicitlyOffCount: number;
        ImplicitCount: number;
        Description: string;
    };
};

export type FeatureFlagTransformed = {
    flag: string;
    enabled: boolean;
    explicitlyOnOrgCount: number;
    explicitlyOffOrgCount: number;
    implicitlyDefaultCount: number;
};

export class FeatureFlagOrgInfo {
    OrganizationId: string;
    OrganizationName: string;
    Value: boolean;
}

export class ImplicitFeatureFlagOrganizationInfo {
    OrganizationId: string;
    OrganizationName: string;
}

export type FeatureFlagsImplicitsFilter = {
    Flag: string;
};

export type FeatureFlagsDetailsFilter = {
    Flag: string;
    Organization?: boolean;
};

export class FeatureFlagOrgsSearchInfo extends SearchResult<FeatureFlagOrgInfo> {}
export class FeatureFlagImplicitOrgSearchInfo extends SearchResult<ImplicitFeatureFlagOrganizationInfo> {}
